import { render, staticRenderFns } from "./RelTrain.vue?vue&type=template&id=1aa663b4&scoped=true"
import script from "./RelTrain.vue?vue&type=script&lang=js"
export * from "./RelTrain.vue?vue&type=script&lang=js"
import style0 from "./RelTrain.vue?vue&type=style&index=0&id=1aa663b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa663b4",
  null
  
)

export default component.exports